module.exports = __webpack_public_path__ + "static/tat-15-55bb6fba985007071446b894c93c6657.jpg";